export const TABLE_DATA_TYPE = 'data';
export const TABLE_NODATA_TYPE = 'nodata';
export const TABLE_FLEX_TYPE = 'flex';
